
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { PageQuery } from '@/mixins/page_query';
import { toast } from '../../../utils/common';
import { iSelectGameAccount, iGameAccount } from '@/interface/game-manage';
import { getGameAccountList, delGameAccount, postUpdateGameAccount, updateTimesLimit } from '@/api/game-manage';
import UploadFile from './FileUpload/upload.vue';
import UploadOffOnlineFile from './FileUpload/uploadOffOnlineFile.vue';
@Component({ components: { UploadFile, UploadOffOnlineFile } })
export default class GameManage extends Mixins(PageQuery) {
  @Prop() game_id!: number;

  private visible: boolean = false;
  private loading: boolean = false;
  private fialDialog: boolean = false;
  private isUpateAccountNum: boolean = false;
  private title: string = '新增游戏';
  private tableData: iGameAccount[] = [];
  private shallowtableData: iGameAccount[] = [];
  private num: number = 0;
  private oldNum: number = 0;
  private query: iSelectGameAccount = {
    username: '',
    status: 0,
    game_id: 0,
  };
  private accountType: object[] = [
    { label: '全部账号', value: 0 },
    { label: '开启', value: 1 },
    { label: '禁用', value: 2 },
  ];

  search() {
    this.page_query.page = 1;
    this.getSearchList();
  }
  handleIsUpdateAccountNum(val: boolean) {
    this.isUpateAccountNum = val;
    if (!val) {
      this.num = this.oldNum;
    }
  }
  async handleUpdateAccount() {
    //处理
    try {
      this.loading = true;

      const res: any = await updateTimesLimit({ id: this.game_id, times_limit: this.num });
      if (res && res.code == 0) {
        toast('操作成功!');
        this.isUpateAccountNum = false;
        this.getSearchList();
      } else {
        toast(res.msg, 'error');
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.loading = false;
    }
  }

  /* 显示修改账号的输入框 */
  editRow(row: any) {
    row.editor = true;
  }
  /* 切换禁用 */
  switchCode(row: any) {
    const { id, status, offline_cache_name, offline_cache_md5 } = row;
    const model: iGameAccount = {
      id: id,
      status: status,
      offline_cache_name: offline_cache_name,
      offline_cache_md5: offline_cache_md5 ? offline_cache_md5 : '',
    };
    //console.log(row, model, '禁用');

    this.updataGameAccount(model);
  }
  /* 修改密码 */
  updateRow(row: any) {
    const { id, pwd, offline_cache_name, offline_cache_md5 } = row;

    const model: iGameAccount = {
      id: id,
      pwd: pwd,
      offline_cache_name: offline_cache_name,
      offline_cache_md5: offline_cache_md5 ? offline_cache_md5 : '',
    };
    this.updataGameAccount(model);
  }
  closeOffLineFile() {
    this.loading = false;
  }
  uploadOffLineFileSuccess(info: any, rowData: any) {
    rowData.offline_cache_name = info.source_file_name;
    rowData.offline_cache_md5 = info.save_file_name + info.file_ext;

    this.updataGameAccount(rowData);
  }
  //删除缓存文件
  deteleOffLine(row: any) {
    this.$msgbox({
      title: '提示',
      message: '删除后，不可恢复，且如果线上用户正在使用，会影响使用，确定删除吗？',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          this.loading = true;
          let res: any;
          row.offline_cache_name = '';
          row.offline_cache_md5 = '';
          this.updataGameAccount(row);
          done();
          instance.confirmButtonLoading = false;
          this.loading = false;
        } else if (action === 'cancel') {
          done();
          instance.confirmButtonLoading = false;
          this.loading = false;
        }
      },
    })
      .then(() => {})
      .catch(() => {
        //  console.log(err);
        this.loading = false;
      });
  }
  async updataGameAccount(model: any) {
    try {
      this.loading = true;
      const res: any = await postUpdateGameAccount(model);
      if (res && res.code == 0) {
        toast('操作成功!');
        this.getSearchList();
      } else {
        toast(res.msg, 'error');
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.loading = false;
    }
  }

  /* 取消修改 */
  cancelEdit(row: any) {
    this.tableData = JSON.parse(JSON.stringify(this.shallowtableData));
    row.editor = false;
  }
  startUploadOffLine() {
    this.loading = true;
  }
  /* 删除游戏账号*/
  removeRow(row: any) {
    this.$msgbox({
      title: '提示',
      message: '确认删除该账号吗？',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          this.loading = true;
          let res: any;
          res = await delGameAccount(row.id);
          if (res && res.code == 0) {
            toast('删除成功');
            this.getSearchList();
          } else {
            toast(res.msg, 'error');
          }
          done();
          instance.confirmButtonLoading = false;
          this.loading = false;
        } else if (action === 'cancel') {
          done();
          instance.confirmButtonLoading = false;
          this.loading = false;
        }
      },
    })
      .then(() => {})
      .catch(() => {
        //  console.log(err);
        this.loading = false;
      });
  }

  async getSearchList() {
    try {
      //  console.log('开始查询账号');
      this.loading = true;
      const res = await getGameAccountList({ ...this.page_query, ...this.query });
      //  console.log(res.data);
      if (res.data.list) {
        this.tableData = res.data.list.map((item: any) => {
          return {
            id: item.id,
            username: item.username,
            pwd: item.pwd,
            status: item.status,
            editor: false,
            offline_cache_name: item.offline_cache_name,
            offline_cache_md5: item.offline_cache_md5,
          };
        });
      } else {
        this.tableData = [];
      }
      this.shallowtableData = JSON.parse(JSON.stringify(this.tableData));
      this.total = res.data.total;
      this.num = res.data.times_limit;
      this.oldNum = this.num;
      // console.log(this, this.tableData);
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  mounted() {
    this.query.game_id = this.game_id;
    this.getSearchList();
  }
  @Watch('game_id')
  onChangeValue(newVal: number, oldVal: number) {
    //  console.log(newVal, oldVal);
    if (newVal != oldVal) {
      this.query.game_id = newVal;
      this.getSearchList();
    }
  }
}
